
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import accountEpic from 'middleware/account';
import noteEpic from 'middleware/note';
import dataEpic from 'middleware/data';
import familyEpic from 'middleware/family';
import groupEpic from 'middleware/group';
import notificaitonEpic from 'middleware/notification';
import settingsEpic from 'middleware/settings';
import dependencies from 'middleware/dependecies';
import rootReducer from 'store';

const rootEpic = combineEpics(
  accountEpic,
  dataEpic,
  familyEpic,
  groupEpic,
  noteEpic,
  settingsEpic,
  notificaitonEpic,
);

const epicMiddleware = createEpicMiddleware({ dependencies });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  const store = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(epicMiddleware),
    ),
  );

  epicMiddleware.run(rootEpic);

  const persistor = persistStore(store);

  return { store, persistor };
};
